import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { UnifiedPipelineService } from 'src/app/services/infra/unifiedPipeline/unified-pipeline.service';

export type BannerType = 'review_boundary' | 'activate_prevention';
export type BannerState = 'idle' | 'enabling' | 'enabled';

@Component({
  selector: 'app-issue-prevention-banner',
  templateUrl: './issue-prevention-banner.component.html',
  styleUrls: ['./issue-prevention-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IssuePreventionBannerComponent {
  @Input() bannerType: BannerType = 'review_boundary';
  @Input() issueId = '';

  @Output() reviewBoundaryClicked = new EventEmitter<void>();

  private readonly _unifiedPipelineService = inject(UnifiedPipelineService);

  public state = signal<BannerState>('idle');

  public get blockedActionsLink(): string {
    return this._unifiedPipelineService.isEnabled()
      ? '/app/ai-findings?source=inline&view=individuals'
      : '/app/ai-in-line-control';
  }

  public onButtonClick(): void {
    if (this.bannerType === 'review_boundary') {
      this.reviewBoundaryClicked.emit();
      return;
    }

    this.state.set('enabling');
    setTimeout(() => {
      this.state.set('enabled');
    }, 2000);
  }
}
